import React, { Fragment } from 'react'
import { Box } from '@mui/material'

const sx = {
  imageContainer: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '30px',
      backgroundColor: 'rgb(212,219,224)',
      borderRadius: '0 0 10px 10px',
    },
  },
  wrapperDropdown: {
    position: 'relative',
    '& .dropdown-placeholder': {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      borderRadius: 10,
      overflow: 'hidden',
      '& img': {
        width: '18%',
        marginTop: 1,
      },
    },
  },
}

function FinancialOverviewPlaceholder(props) {
  const isReceivable = props.isReceivable
  const isWithDropPlaceholder = props.isWithDropPlaceholder
  return (
    <Fragment>
      <Box sx={isReceivable ? sx.imageContainer : {}}>
        <img className="w-100" src={props.graphImage} alt="" />
      </Box>
      <Box sx={isWithDropPlaceholder ? sx.wrapperDropdown : {}} className={`mt-3`}>
        <img className="w-100" src={props.tableImage} alt="" />
        {isWithDropPlaceholder && (
          <div className="dropdown-placeholder">
            <img src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/png/dropdown.png'} alt="" />
          </div>
        )}
      </Box>
    </Fragment>
  )
}

export default FinancialOverviewPlaceholder
